import type { SVGProps } from "react";
import { HomePlateIcon } from "./home-plate-icon";
import { cn } from "@/lib/utils";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAuth } from "@/context/auth-context";

export function DiamondIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="m12 2 10 10-10 10-10-10Z" />
    </svg>
  );
}

type AppLogoProps = {
  iconSize?: string;
  textSize?: string;
  iconClassName?: string;
};

export function AppLogo({
  iconSize = "size-7",
  textSize = "text-lg",
  iconClassName,
}: AppLogoProps) {
  const isMobile = useIsMobile();
  const { uiMode } = useAuth();

  return (
    <div className="flex items-center gap-2">
      <span
        className={cn(
          "font-bold tracking-tight text-primary-foreground bg-primary px-2 py-1 rounded-md transition-opacity",
          // Hide text when sidebar is collapsed to icon mode
          "group-data-[collapsible=icon]:hidden",
          isMobile ? "hidden" : "inline-block",
          textSize,
        )}
      >
        OfficialsPay
        {uiMode === "multi-sport" && (
          <>
            {" "}
            <span className="text-xs font-normal opacity-80">Multi-Sport</span>
          </>
        )}
      </span>
    </div>
  );
}

export function BaseballSad(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M8 15a4 4 0 0 0 8 0" />
      <circle cx="9" cy="10" r="0.5" fill="currentColor" />
      <circle cx="15" cy="10" r="0.5" fill="currentColor" />
      <path d="M3.5 9.5a10.4 10.4 0 0 1 5-5.5" />
      <path d="M20.5 9.5a10.4 10.4 0 0 0-5-5.5" />
    </svg>
  );
}

export function BaseballNeutral(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="8" y1="15" x2="16" y2="15" />
      <circle cx="9" cy="10" r="0.5" fill="currentColor" />
      <circle cx="15" cy="10" r="0.5" fill="currentColor" />
      <path d="M3.5 9.5a10.4 10.4 0 0 1 5-5.5" />
      <path d="M20.5 9.5a10.4 10.4 0 0 0-5-5.5" />
    </svg>
  );
}

export function BaseballHappy(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M8 14s1.5 2 4 2 4-2 4-2" />
      <circle cx="9" cy="9" r="0.5" fill="currentColor" />
      <circle cx="15" cy="9" r="0.5" fill="currentColor" />
      <path d="M3.5 9.5a10.4 10.4 0 0 1 5-5.5" />
      <path d="M20.5 9.5a10.4 10.4 0 0 0-5-5.5" />
    </svg>
  );
}

export function BaseballIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M3.5 9.5a10.4 10.4 0 0 1 5-5.5" />
      <path d="M20.5 9.5a10.4 10.4 0 0 0-5-5.5" />
    </svg>
  );
}
